import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { postJwt } from '../authws/post-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';
import { defaultRoutingProfileSchema } from './schemas/routing-profile.schema';
import { UnitsOfMeasurement } from './schemas/units-of-measurement.schema';
import { vehicleDimensionsThresholdSchema } from './schemas/vehicle-dimensions-threshold.schema';

export function getDefaultRoutingProfiles(units: UnitsOfMeasurement) {
  const params = new URLSearchParams();
  params.append('units', String(units === 'Imperial' ? 0 : 1));

  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      return fromFetch(
        new Request(
          `${
            routingProfileServiceEnvironment.defaultRoutingProfilesUrl
          }?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              ...requiredHeaders,
              Authorization: `bearer ${jwt.access_token}`,
            },
          }
        )
      ).pipe(
        selectData(
          z.object({
            data: z.object({
              profiles: z.array(defaultRoutingProfileSchema),
              vehicleDimensionMinMax: z.array(vehicleDimensionsThresholdSchema),
            }),
          })
        )
      );
    })
  );
}
